<template>
  <div
    class="modal fade"
    id="navStoreModal"
    tabindex="-1"
    data-backdrop="static"
    data-keyboard="false"
    aria-labelledby="storeModallabel"
    aria-hidden="true"
    ref="storeModalRef"
    style="z-index: 9999"
    v-if="this.$auth.setting"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="filterLabel">
            {{ $t("Select") }}
            {{ $auth.setting && $auth.setting.restaurant_name }}
          </h4>
          <a data-dismiss="modal" class="lnk" @click="oncloseModle">
            <!-- {{ $t("Close") }} -->
            <svg
              fill="#000000"
              width="25px"
              height="25px"
              viewBox="0 0 32 32"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                <path
                  d="M16 0c-8.836 0-16 7.163-16 16s7.163 16 16 16c8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 30.032c-7.72 0-14-6.312-14-14.032s6.28-14 14-14 14 6.28 14 14-6.28 14.032-14 14.032zM21.657 10.344c-0.39-0.39-1.023-0.39-1.414 0l-4.242 4.242-4.242-4.242c-0.39-0.39-1.024-0.39-1.415 0s-0.39 1.024 0 1.414l4.242 4.242-4.242 4.242c-0.39 0.39-0.39 1.024 0 1.414s1.024 0.39 1.415 0l4.242-4.242 4.242 4.242c0.39 0.39 1.023 0.39 1.414 0s0.39-1.024 0-1.414l-4.242-4.242 4.242-4.242c0.391-0.391 0.391-1.024 0-1.414z"
                ></path>
              </g>
            </svg>
          </a>
        </div>
        <div class="modal-body">
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                <div class="hme-res-itm">
                  <div
                    class="resturant-item-main1 mb-0 active"
                    v-if="
                      stores &&
                      stores.length > 0 &&
                      $auth &&
                      $auth.getVendorId() > 0
                    "
                  >
                    <item
                      v-for="item in stores"
                      :key="item.restaurant_id"
                      :item="item"
                      :isSchedule="
                        $auth.setting
                          .is_enable_schedule_order_after_business_hours
                      "
                      :webVendorLayout="1"
                      components="navbar"
                      v-on:closedModal="oncloseModle"
                      :isPickupDelivery="1"
                      :activeID="activeID"
                    >
                    </item>
                  </div>
                  <div v-else class="modal-body text-center">
                    <p>
                      <span>{{
                        $t(
                          "Service not available in this area. Please change location and try again."
                        )
                      }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import Item from "@/components/Item.vue";
export default {
  components: { Item },
  props: ["activeID"],
  data() {
    return {
      stores: [],
      open_restaurant: "",
    };
  },
  mounted() {
    window.$("#navStoreModal").on("show.bs.modal", function () {});
    window.$("#navStoreModal").modal("show");
    this.getMultipleStore();
  },
  methods: {
    ...mapActions("restaurant", ["getRestaurants"]),

    getMultipleStore() {
      let restData = {
        cityname: localStorage.getItem("city"),
        latitude: localStorage.getItem("latitude"),
        longitude: localStorage.getItem("longitude"),
        is_langauge: this.$store.state.lang.locale,
        vendor_id: this.$auth.getVendorId(),
        state: localStorage.getItem("state"),
        total_record: 1000,
        date: "",
        cuisine_id: "",
        skip: 0,
        starttime: "",
        sort_type: "",
        user_id: "",
        filter_type: "",
        cost_range: "",
      };
      this.getRestaurants(restData).then((data) => {
        if (data.code == 200) {
          this.stores = data.Result;
        }
      });
    },
    oncloseModle() {
      this.$emit("storeModal");
    },
  },
};
</script>
<style>
.modal-body .resturant-item-main1 .rest-item-list1 {
  width: 100%;
}
.rest-item-list1 .active {
  border: 2px solid red;
}
</style>
